import { initModal } from "./modal.js";

const feedback = document.querySelector('#feedback');
initModal(feedback);
